<template>
    <div ref="content" class="data-grid-search" :class="[theme ? `theme--${theme}` : '']">
      <template v-if="shouldSearchForm" >
          <!-- ant design风格 -->
        <template v-if="theme === 'ant'">
            <el-form inline :label-width="labelWidth">
                <el-row>
                  <el-col v-for="(item, index) in items" :key="item.key" :sm="24" :md="8">
                      <el-form-item style="width:100%;" v-show="!collapse || (collapse && index <= 1)" :label="item.label">
                      <template v-if="item.type === 'select'">
                          <el-select v-model="model[item.prop]" :placeholder="item.placeholder" clearable filterable>
                            <el-option v-for="item in remoteData[item.prop]" :key="item.id" :value="item.id" :label="item.label"></el-option>
                          </el-select>
                      </template>
                      <template v-else-if="item.type === 'date'">
                          <el-date-picker v-model="model[item.prop]" :placeholder="item.placeholder"></el-date-picker>
                      </template>
                      <template v-else>
                          <el-input v-model="model[item.prop]" :placeholder="item.placeholder" :type="item.type"></el-input>
                      </template>
                      </el-form-item>
                  </el-col>
                  <el-col :sm="24" :md="span">
                      <el-form-item class="btns" :class="{'is-expanded' : !collapse}" style="margin-left:100px;">
                        <el-button type="primary" @click="onSearch">查询</el-button>
                        <el-button v-if="shouldReset">重置</el-button>
                        <el-button v-if="shouldCollapse" type="text" @click="trigger" data-el="collapse">{{collapse ? '展开' : '收起'}}<i v-if="!collapse" class="el-icon-arrow-up"></i><i v-else class="el-icon-arrow-down"></i></el-button>
                      </el-form-item>
                  </el-col>
                </el-row>
            </el-form>
        </template>
        <template v-else>
            <el-form @submit.native.prevent  inline :label-width="labelWidth" >
                <el-row :gutter="24">
                  <el-col :md="24" :lg="showButton ?  24 - span : 24">
                      <el-row :gutter="gutter">
                        <template v-if="!isSearchInput">
                          <el-col v-for="(item, index) in items" :key="item.key" :sm="24" :md="item.span ? item.span : itemSpan">
                            <el-form-item ref="items" :style="{width:'100%', 'animation-delay': `${index * 80}ms`}" :label="item.label" v-show="!collapse || (collapse && index <= 2)">
                              <template v-if="item.type === 'select' && remoteData[item.prop]">
                                  <el-select v-model="model[item.prop]" @change="(e) => __onChange(e, item)" :placeholder="item.placeholder" :clearable="item.clearable === undefined ? true : item.clearable" filterable :multiple="item.multiple ? item.multiple : false" data-tag="select">
                                    <el-option v-for="ii in remoteData[item.prop]" :key="ii.id" :value="item.options && item.options.id ? ii[item.options.id] : ii.id" :label="item.options && item.options.label ? ii[item.options.label] : ii.label"></el-option>
                                  </el-select>
                              </template>
                              <template v-else-if="item.type === 'cascader' && remoteData[item.prop]">
                                  <el-cascader style="width:100%;" v-model="model[item.prop]" :options="remoteData[item.prop]" :props="{value: 'id', label: 'label', children: 'children', ...item.props}" :placeholder="item.placeholder" clearable :filterable="item.filterable ? item.filterable : false" data-tag="cascader"/>
                              </template>
                              <template v-else-if="item.type === 'date'">
                                  <el-date-picker v-model="model[item.prop]" data-tag="date" :placeholder="item.placeholder" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"></el-date-picker>
                              </template>
                              <template v-else-if="item.type === 'month'">
                                  <el-date-picker v-model="model[item.prop]" data-tag="month" :placeholder="item.placeholder" type="month" format="yyyy 年 MM 月" value-format="yyyy-MM"></el-date-picker>
                              </template>
                              <template v-else-if="item.type === 'daterange'">
                                <el-date-picker
                                 :clearable="item.clearable === undefined ? true : item.clearable"
                                 @change="(e) => __onChange(e, item)"
                                  v-model="model[item.prop]"
                                  type="daterange"
                                  data-tag="daterange"
                                  unlink-panels
                                  range-separator="-"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  format="yyyy-MM-dd"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="item.pickerOptions === undefined ? globalPickerOptions :item.pickerOptions">
                                </el-date-picker>
                              </template>
                              <template v-else-if="item.type !== 'select' && item.type !== 'cascader' && item.type !== 'date' && item.type !== 'daterange'">
                                  <el-input v-model="model[item.prop]" data-tag="text" :placeholder="item.placeholder" :type="item.type" :maxlength="item.maxlength"></el-input>
                              </template>
                            </el-form-item>
                          </el-col>
                        </template>
                        <div class="search-input-wrap" v-else>
                          <el-input
                            @keydown.native.enter="onSearch"
                            :placeholder="items[0].placeholder"
                            v-model="model[items[0].prop]">
                            <i @click="onSearch" slot="suffix" class="el-input__icon el-icon-search search-btn"></i>
                          </el-input>
                        </div>
                      </el-row>
                  </el-col>
                  <el-col :md="24"  :lg="span" v-if="showButton" >
                      <el-form-item class="btns hidden-md-and-down" :class="{'is-expanded' : !collapse}">
                        <el-button v-if="!isSearchInput" type="primary" @click="onSearch" data-el="search">查询</el-button>
                        <el-button v-if="shouldReset" @click="reset" data-el="reset">重置</el-button>
                        <el-button v-if="shouldCollapse" type="text" @click="trigger" data-el="collapse">{{collapse ? '展开' : '收起'}}<i v-if="!collapse" class="el-icon-arrow-up"></i><i v-else class="el-icon-arrow-down"></i></el-button>
                      </el-form-item>
                      <el-form-item  class="btns hidden-lg-and-up" style="text-align: left;" :class="{'is-expanded' : !collapse}">
                        <el-button v-if="!isSearchInput" type="primary" @click="onSearch" data-el="search">查询</el-button>
                        <el-button v-if="shouldReset" @click="reset" data-el="reset">重置</el-button>
                        <el-button v-if="shouldCollapse" type="text" @click="trigger" data-el="collapse">{{collapse ? '展开' : '收起'}}<i v-if="!collapse" class="el-icon-arrow-up"></i><i v-else class="el-icon-arrow-down"></i></el-button>
                      </el-form-item>
                  </el-col>
                </el-row>
            </el-form>
        </template>
      </template>
    </div>
</template>

<script>
import ResponsiveObserver from 'responsive-observer'
import {removeClass} from '@/libs/dom'
const TYPE = ['text', '', 'date', 'daterange', 'select', 'cascader']
const DEAD_TYPE = ['text', '', 'date', 'daterange']

/* istanbul ignore next */
function getDays (start, num) {
  let days = 0
  for (let i = 0; i < num; ++i) {
    days += new Date(start.getFullYear(), start.getMonth() - i, 0).getDate()
  }
  return days
}

export default {
  name: 'searchbar',
  props: {
    search: { // 当只有一个单行文本输入框时是否展现为搜索框
      type: Boolean,
      defalut: true
    },
    theme: {
      type: String, // 可选值 ant
      defalut: ''
    },
    value: {
      type: Object,
      /* istanbul ignore next */
      default () {
        /* istanbul ignore next */
        return {}
      }
    },
    items: {
      type: Array,
      defalut: () => {
        /* istanbul ignore next */
        return []
      }
    },
    labelWidth: {
      type: String,
      default: ''
    },
    autoReset: {
      type: Boolean,
      default: true
    },
    showButton: {
      type: Boolean,
      default: true
    },
    gutter: {
      type: Number,
      default: 24
    }
  },
  computed: {
    shouldCollapse () {
      return this.items.length > 3
    },
    shouldReset () {
      return !this.isSingle
    },
    /**
     * @description 是否为预定义搜索框
     */
    isSearchInput () {
      return this.search && this.isSingle && (!this.items[0].type || this.items[0].type === 'text')
    },
    /**
     * @description 是否显示表单
     */
    shouldSearchForm () {
      return this.items && this.items.length > 0
    },
    isSingle () {
      if (!this.items) return 0
      return this.items.length === 1
    },
    itemSpan () {
      if (!this.items) return 0
      // 一行三个
      if (this.items.length >= 3) {
        return 8
      } else {
        // return this.isSingle ? 24 : 12
        return this.screens.xl && this.isSingle ? 24 : 12
      }
    },
    span () {
      if (!this.items) return 0
      if (this.items.length > 3 && !this.collapse && this.theme === 'ant') return 24
      else if (this.items.length > 3 && this.theme === 'ant') return 8
      else if (this.items.length > 3) return 8
      else {
        return 24 - this.items.length * 6
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val) this.model = val
      }
    },
    model: {
      deep: true,
      handler () {
        this.emitInput(this.model)
      }
    },
    items: {
      deep: true,
      handler () {
        this.__init()
      }
    }
  },
  data () {
    return {
      collapse: false,
      screens: {},
      height: 0,
      model: {},
      globalPickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            /* istanbul ignore next */
            {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
              picker.$emit('pick', [start, end])
            }
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            /* istanbul ignore next */
            {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * getDays(start, 1))
              picker.$emit('pick', [start, end])
            }
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            /* istanbul ignore next */
            {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * getDays(start, 3))
              picker.$emit('pick', [start, end])
            }
          }
        }]
      },
      remoteData: {} // 远程数据 存储下拉框级联框等组件数据
    }
  },
  methods: {
    emitInput (value = {}) {
      this.$emit('input', value)
    },
    onSearch () {
      this.$emit('search')
    },
    __init () {
      this.__initHeight()
      this.__initRemoteData()
    },
    __initHeight () {
      this.$nextTick(() => {
        /* istanbul ignore else */
        if (this.$refs.content) {
          this.height = this.$refs.content.offsetHeight
          this.$emit('trigger')
        }
      })
    },
    trigger () {
      if (this.$refs.items) {
        this.$refs.items.forEach((item, index) => {
          if (index > 2) {
            removeClass(item.$el, 'fadeInUp')
          }
        })
      }
      this.collapse = !this.collapse
      this.__initHeight()
    },
    /**
     * @description 重置表单
     */
    reset () {
      // TODO 重置操作放在父组件做比较好，这里暂时这么做了
      if (this.autoReset) {
        Object.keys(this.model).forEach(k => {
          if (Array.isArray(this.model[k])) this.model[k] = []
          else this.model[k] = ''
        })
      } else {
        this.$emit('reset')
      }
    },
    __getRemoteData (api, prop, params = {}) {
      if (!prop) {
        throw new Error(`form item prop cannot be empty.`)
      }
      if (!api) {
        // TODO 以后可能会新增类型
        throw new Error(`When a form item type is not a text, date, daterange, you must provide a remote API：${prop}.`)
      }
      /* istanbul ignore next */
      this.$api(api, params).then(res => {
        this.$set(this.remoteData, prop, res)
      }).catch(err => {
        this.$tips(err, 'error')
      })
    },
    __initRemoteData () {
      if (!this.items) return
      let seedItems = this.items.filter(item => {
        return DEAD_TYPE.indexOf(item.type) === -1 && TYPE.indexOf(item.type) !== -1
      })
      seedItems.forEach(seed => {
        // data：用户自己传入不需要再次请求后台
        if (this.remoteData[seed.prop] && this.remoteData[seed.prop].length > 0 && !seed.data) return
        if (!seed.data) {
          if (seed.prop) this.$set(this.remoteData, seed.prop, []) // 标准的远程数据应该都是数组
          this.__getRemoteData(seed.api, seed.prop, seed.params ? seed.params : {})
        } else {
          if (!seed.prop) {
            throw new Error(`form item prop cannot be empty.`)
          }
          this.$set(this.remoteData, seed.prop, seed.data)
        }
      })
    },
    __onChange (e, item) {
      if (item && item.on) {
        if (typeof item.on.change === 'function') {
          item.on.change(e)
        }
      }
    }
  },
  mounted () {
    this.__init()
  },
  created () {
    this.observer = new ResponsiveObserver()
    this.observer.subscribe((screens) => {
      this.screens = screens
    })
  },
  destroyed () {
    if (this.observer) this.observer.unsubscribe()
  }
}
</script>

<style lang="less">
.hiddenMdAndUp {
  text-align: right;
}
.data-grid-search {
  & {
    .el-form .el-form-item {
      display: flex;
      .el-form-item__content {
        flex: 1;
      }

      .el-select, .el-date-editor {
        width: 100%;
      }
    }
  }
  &.ant {
    .btns.is-expanded {
        .el-form-item__content {
          text-align: right;
        }
    }
  }
  .search-input-wrap {
    width: 240px;
    padding-bottom: 20px;
    .el-input.el-input--small {
      .el-input__inner {
        border-radius: 16px;
      }
    }
    .search-btn {
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/searchbar.vue